export const GETTING_STARTED_HEADING = 'Getting Started';
export const GETTING_STARTED_DESCRIPTION = 'Sign up and Download QuickCam.';
export const GETTING_STARTED_DETAILS = `To download and activate QuickCam, register for a free ProManager
account. You can use the same ProManager account to login and access all
the apps for iPhone, Android & websites with the "Login with
ProManager".`;
